"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    profileMask: {
        borderRadius: '50%'
    }
};
//# sourceMappingURL=avatar.styles.js.map